<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import ArticleMedia from './Media.vue'
	import Multiselect from 'vue-multiselect'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'article-media': ArticleMedia,
			'multiselect': Multiselect,
		},
		watch: {
			'item.title'() {
				this.item.item.slug = this.$options.filters.slugify(this.item.title)
			},
			'item.item.slug'() {
				this.checkSlug()
			},
			category() {
				this.item.item.category_id = null
				if(this.category) {
					this.item.item.category_id = this.category.id
				}
				this.checkSlug()
			}
		},
		data () {
			return {
				languages: null,
				statuses: null,
				categories: [],

				category: null,
				lang_id: null,

				slug_in_use: false,

				item: null,

				id: this.$route.params.id,

				loading: false,

				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_IMAGES,
					url: null,
					maxFileSizeInMB: 20,
					maxNumberOfFiles: 10,
				},

				editorDescription: true,
				editorContent: true,
			}
		},
		created() {
			this.init()
		},
		mounted() {
			[].slice.call(document.querySelectorAll('.sttabs')).forEach(function(el) {
				new CBPFWTabs(el);
			})
		},
		methods: {
			init() {
				this.getData()
				this.getLanguages()
				this.getStatuses()
			},
			reload() {
				if(this.$refs.mediacreate) {
					this.$refs.mediacreate.close()
				}
				this.getData()
			},
			getData() {
				this.$http.get('admin/cms/articles/' + this.id + '/edit')
					.then(response => {
						this.item = response.body
						this.getCategories(true)
						this.dropzone.url = process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/cms/articles/' + this.item.id
					})
			},
			getLanguages: function() {
				this.$http.get('languages')
					.then(response => {
						this.languages = response.body
					})
			},
			getStatuses() {
				this.$http.get('admin/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			getRoles() {
				this.$http.get('admin/roles')
					.then(response => {
						this.roles = response.body
					})
			},
			getCategories(loadCategory = false) {
				this.categories = []
				this.category = null
				var data = {
					lang_id: this.lang_id,
					id: this.item.category_id,
				}
				this.$http.post('admin/cms/categories/get', data)
					.then(response => {
						this.categories = response.body
						if(loadCategory) {
							this.loadCategory()
						}
					})
			},
			loadCategory() {
				this.category = null
				if(this.categories) {
					if(this.categories.length) {
						var that = this
						var found = this.categories.find(function(element) {
							return element.id == that.item.item.category_id
						})
						if(found) {
							this.category = found
						}
					}
				}
				this.loadLang()
			},
			loadLang() {
				this.lang_id = null
				if(this.category) {
					this.lang_id = this.category.lang_id
				}
			},
			checkSlug(update = false) {
				this.loading = true
				if(this.item.item.slug) {
					var data = {
						id: this.item.item.id,
						slug: this.item.item.slug,
						category_id: this.item.item.category_id,
					}
					this.$http.post('admin/cms/articles/check/slug', data)
						.then(response => {
							var in_use = response.body
							this.slug_in_use = in_use > 0
							this.loading = false
							if(update) {
								this.update()
							}
						})
				} else {
					this.loading = false
				}
			},
			validate() {
				var that = this
				if(this.loading) {
					return false
				
				}if(this.slug_in_use) {
					return false
				}
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.checkSlug(true)
					}
					if(that.$validator.errors.items.length) {
						that.$el.querySelector('[name=' + that.$validator.errors.items[0].field + ']').focus()
					}
					return result
				})
			},
			update () {
				if(!this.loading) {
					if(!this.slug_in_use) {
						var loadingTop = Ladda.create(this.$refs.btnStoreTop)
						var loadingBottom = Ladda.create(this.$refs.btnStoreBottom)
						loadingTop.start()
						loadingBottom.start()
						this.$http.put('admin/cms/articles/' + this.item.id, this.item)
							.then(response => {
								loadingTop.stop()
								loadingBottom.stop()
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							}).catch(function(response) {
								console.log(response)
								loadingTop.stop()
								loadingBottom.stop()
								if(response.status == 409) {
									swal({
										title: response.body.title,
										text: response.body.text,
										type: response.body.type,
									})
								}
							})
					}
				}
			},
			destroyCover() {
				var media = this.item.cover
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete(process.env.ROOT + '/api/' + that.$lang.getLang() + '/admin/media/' + media.id + '/destroy')
							.then(response => {
								that.$set(that.item, 'cover', null)
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								})
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			stripHTMLDescription() {
				var html = this.item.description
				var div = document.createElement("div")
				div.innerHTML = html
				var text = div.textContent || div.innerText || ""
				this.item.description = text
			},
			stripHTMLContent() {
				var html = this.item.content
				var div = document.createElement("div")
				div.innerHTML = html
				var text = div.textContent || div.innerText || ""
				this.item.content = text
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/cms/articles/views/Edit.vue